<template>
    <div class="">
        <div class="container">
            <h2>100T+ Submission Form</h2>
            <div class="">
                <p>
                    To have your personal banknote collection submitted to Banknote World's 100T+ Authentication, follow
                    these
                    steps: <br>
                    <span class="font-weight-bolder">1. Fill out the Banknote Submission Form.</span> <br>
                    Select the banknotes you would like to submit from the drop-down menu options. Enter the serial
                    number
                    for each banknote and click save. Add additional banknotes and once you are finished click "Continue
                    to
                    Checkout" <br>
                    <span class="font-weight-bolder">2. Prepare your banknotes to be mailed.</span> <br>
                    Postmark the address to: <br>
                    BNWorld, Inc.<br>
                    11721 Seaboard Circle <br>
                    Stanton, CA 90680 <br>
                    <span class="text-danger font-weight-bolder">Please Note:</span> This service is ONLY for raw
                    banknotes
                    to be 100T+ authenticated and is not intended for
                    banknotes that have been purchased already encased and "100T+". Purchased 100T+ banknotes are already
                    registered and there is no need for them to be re-entered into the 100T+ submission page.
                </p>
            </div>
        </div>
        <div class="gray-bg">
            <div class="container">
                <SubmissionForm v-for="(item,index) in items"
                                :key="index"
                                :form="item"
                                :options="options"
                                @storeTap="storeTap"
                />
                <b-button variant="primary" class="" @click="addNew">Add Another Note</b-button>
            </div>
        </div>
        <div class="container">
            <b-button :disabled="disableCheckout || addingToCart"
                      variant="primary"
                      class="mt-4" @click="checkout">
                <span v-if="!addingToCart">Continue To Checkout</span>
                <span v-else>Loading... <b-spinner small/></span>
            </b-button>
        </div>
    </div>
</template>

<script>
import SubmissionForm from './SubmissionForm';

export default {
    name: 'Submissions',
    components: {SubmissionForm},
    data() {
        return {
            loading: true,
            addingToCart: false,
            items: [
                {
                    tap_banknote_id: null,
                    serial_number: '',
                    valid: false,
                },
            ],
            options: [],
        };
    },
    mounted() {
        this.getOptions();
        if (localStorage.getItem('submissions')) {
            this.items = JSON.parse(localStorage.getItem('submissions'));
        }
    },
    computed: {
        disableCheckout() {
            let disable = true;
            this.items.forEach(item => {
                if (item.valid) {
                    disable = false;
                }
            });
            return disable;
        },
    },
    methods: {
        storeTap() {
            const temp = this.items.filter(item => item.valid);
            localStorage.setItem('submissions', JSON.stringify(temp));
        },
        getOptions() {
            $.ajax({
                method: 'GET',
                url: '/api/get_tap_submission_product',
            })
                .then(res => {
                    ;
                    this.options = res.data;
                })
                .catch((xhr) => {
                  this.$errorNotify(xhr.responseJSON.message)
                })
                .always(() => {
                    this.loading = false;
                });
        },
        addNew() {
            this.items.push({
                tap_banknote_id: null,
                serial_number: '',
                valid: false,
            });
        },
        checkout() {
            this.addingToCart = true;
            $.ajax({
                method: 'POST',
                url: route('cart.items.store', {
                    product_id: +localStorage.getItem('banknote_submission_product_id'),
                    qty: 1,
                    tap_submission: localStorage.getItem('submissions'),
                }),
            })
                .then((cart) => {
                    window.location.href = route('checkout.create');
                })
                .catch((xhr) => {
                  this.$errorNotify(xhr.responseJSON.message)
                })
                .always(() => {
                    this.addingToCart = false;
                });
        },
    },
};
</script>

<style scoped>
h2 {
    font-size: 1.75rem;
    color: #DEAA5E;
    margin-bottom: 1.75rem;
    margin-top: 2.1rem;
    font-weight: 700;
}

p, p span {
    font-size: 1rem;
    line-height: 2.4rem;
}

.gray-bg {
    background-color: #F1F3F7;
    padding: 2rem 0;
}
</style>
